import ResponsiveImage from '~/components/Image/ResponsiveImage'
import { getAspectRatio } from '~/MathTopics/utils/math-topic.utils'

interface TopicHeadingProps {
  topicId: string
  title: string
}

export default function TopicHeading(props: TopicHeadingProps): React.ReactElement {
  const { topicId, title } = props

  const aspectRatio = getAspectRatio(topicId)
  const mediaQuery = [{ screen: '(min-width: 280px)', width: `${aspectRatio.width}px` }]
  return (
    <div className="flex items-center justify-center md:justify-start mb-8">
      <div className="flex flex-col md:flex-row items-center justify-center">
        <ResponsiveImage
          alt={title}
          height={aspectRatio.height}
          imageClassName="w-auto h-30"
          imageWidths={`${aspectRatio.width}`}
          mediaQuery={mediaQuery}
          srcKey={`math-topics/${topicId}-v3.png`}
          width={aspectRatio.width}
        />
        <div className="ml-5 text-black-light-fade text-center text-7 font-bold leading-11 tracking-[2.736px]">
          {title}
        </div>
      </div>
    </div>
  )
}
